<template>
  <el-table-column
    prop="supplier_name"
    label="Beszállító"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.supplier_name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'supplier.name',
  };
</script>
